import { RoleFunction } from '../../../../constants/projectUsers';
import { checkRoles } from '../../../../utils/checkRoles';

/**
 * "Dyskusja z ekspertem" is the chat between the case author and the Administrator merytoryczny
 * ("Dokument funkcjonalny" + RR-250): a publishing user may start it only on their own case, the
 * expert may always start it, everyone else can read the thread but not open one.
 *
 * The expert is never the author of a case description, so `isAuthor` must not gate them (RR-606).
 */
export const canStartDiscussion = (roleFunction: RoleFunction | null, isAuthor: boolean) =>
  (checkRoles(roleFunction, [RoleFunction.ROLE_PUBLISHING]) && isAuthor) ||
  checkRoles(roleFunction, [RoleFunction.ROLE_EXPERT]);
